/**
 * 참고: https://github.kakaocorp.com/kakaopage/api/blob/ad75ae912870621c23e6659954e59b4314020c8a/common/src/main/java/com/kakaopage/common/model/enums/CategoryType.java#L15
 */

export enum CategoryTypeVo {
  // 알수없음
  None = 0,
  // 만화
  Cartoon = 10,
  // 소설
  Novel = 11,
  // 책
  Book = 16,
  // 톡드립
  TalkDrip = 18,
  // 영화
  Movie = 21,
  // 방송
  Broadcast = 22,
  // 카톡소설
  KatalkNovel = 1000,
}
